var Coupon = {
  init: function() {
    $('#addCouponImage').on('click', function() {
      $('#coupon-image').click();
    });
    $('input[type="file"]').change(function(e){
      var fileName = e.target.files[0].name;
      $(".file-added.list-group-item-danger").remove();
      $('#files-added').append('<li class="list-group-item file-added">' + fileName + '</li>');
      Coupon.compressCouponImage();
    });
    $('.save-coupon').on('click', Coupon.saveCoupon);
  },

  compressedImage: null,

  compressCouponImage: function(){
    const file = document.getElementById("coupon-image").files[0];
    if (!file) return;
    new Compressor(file, {
      quality: 0.6,
      height: 720,
      success(result) {
        $("#coupon-image").val(null);
        Coupon.compressedImage = result;
      },
      error(err) {
        console.log(err.message);
      },
    });
  },

  saveCoupon: function() {
    $('#save-coupon-success, #save-coupon-already-exists, #save-failed').hide();
    $("#firstName").removeClass('alert-danger');
    $("#user-phone").removeClass('alert-danger');
    $("#center").removeClass('alert-danger');
    var code = $('#coupon-code');

    window.scrollTo({ top: 0, behavior: 'smooth' });

    if(!FormValidation.checkFileSize($("#coupon-image")[0])) {
      console.log("file too big");
      $(".file-added").addClass('list-group-item-danger');
      $(".file-added").append('<div class="small">Fail peab olema väiksem kui 15mb</div>');
      $('#save-failed').slideDown();
      return false;
    }

    Coupon.postCouponCode(code.val())
      .done(function(response) {
        if (response.saveSuccessful) {
          $('#save-coupon-success').slideDown();
          code.val('');
          $('#coupon').find('select').val('');
        } else {
          $('#save-coupon-already-exists').slideDown()
        }
        $('.save-coupon').prop("disabled", false);
      })
  },

  postCouponCode: function(code) {
    var form_data = new FormData();
    form_data.append("code", $("#coupon-code").val());
    form_data.append("firstName", $("#firstName").val());
    form_data.append("lastName", $("#lastName").val());
    form_data.append("phone", $('#user-phone').val());
    form_data.append("center", $('#coupon-center').val());
    if(Coupon.compressedImage != null){
      form_data.append("coupon-image", Coupon.compressedImage, Coupon.compressedImage.name);
    }else{
      form_data.append("coupon-image", $("#coupon-image").prop("files")[0]);
    }
    $('.save-coupon').prop("disabled", true);
    return $.ajax({
      url: "/coupon/save/",
      cache: false,
      contentType: false,
      processData: false,
      data: form_data,
      type: 'post',
      error: function (e) {
        if(e.status===400){
          if(($("#coupon-image").prop("files")[0]) === undefined && $("#coupon-code").val() === ""){
            $('#save-failed').slideDown()
          }
          if($("#firstName").val() === ""){
            $("#firstName").addClass('alert-danger');
            $('#save-failed').slideDown();
          }
          if($("#user-phone").val() === ""){
            $("#user-phone").addClass('alert-danger');
            $('#save-failed').slideDown();
          }
          if($("#center").val() === undefined){
            $("#center").addClass('alert-danger');
            $('#save-failed').slideDown();
          }
        }
      }
    })
  }
};
